/**
 * `react-select`'s `unstyled` mode strips its default inline styles; every visual comes from this
 * shared `classNames` map instead, matching the rest of the app's Tailwind tokens (`min-h-tap` for
 * the 44px tap target). Shared by every grouped picker in the app (the character form's class
 * picker in `routes/Characters.tsx`, the account form's world picker, and the screenshot-import
 * review table's per-row class picker) so they stay visually identical without copy-pasting this
 * object.
 */
export const selectClassNames = {
  control: (state: { isFocused: boolean }) =>
    [
      'min-h-tap w-full items-center rounded-lg border bg-bg-elevated-hover px-3 text-sm text-text transition-colors',
      state.isFocused ? 'border-accent' : 'border-border-strong',
    ].join(' '),
  valueContainer: () => 'gap-1 py-1',
  input: () => 'text-text',
  placeholder: () => 'text-text-faint',
  singleValue: () => 'text-text',
  indicatorsContainer: () => 'gap-1',
  dropdownIndicator: () => 'px-1 text-text-faint',
  clearIndicator: () => 'px-1 text-text-faint hover:text-text-muted',
  indicatorSeparator: () => 'hidden',
  menu: () => 'mt-1 overflow-hidden rounded-lg border border-border-strong bg-bg-elevated shadow-2xl',
  menuList: () => 'max-h-64 overflow-y-auto py-1',
  group: () => 'py-1',
  groupHeading: () => 'px-3 pb-1 pt-2 font-display text-xs font-semibold uppercase tracking-wider text-text-faint',
  option: (state: { isFocused: boolean; isSelected: boolean }) =>
    [
      'flex min-h-tap cursor-pointer items-center px-3 text-sm',
      state.isSelected
        ? 'bg-accent text-accent-contrast'
        : state.isFocused
          ? 'bg-accent-dim text-text'
          : 'text-text-muted',
    ].join(' '),
  noOptionsMessage: () => 'px-3 py-2 text-sm text-text-muted',
};
